<nav class="navbar">
  <div class="navbar-left">
    <div class="navbar-brand">
      <div class="brand-logo">
        <img src="/images/valamar_logo_T.png" alt="Valamar Logo" class="logo-image">
      </div>
      <div class="brand-text">
        <span class="brand-name">VALAMAR</span>
        <span class="brand-subtitle">Payment Journey</span>
      </div>
    </div>
    <a class="nav-link" routerLink="/policies/payment" routerLinkActive="active">Policies</a>
  </div>

  <div class="navbar-right">
    <div class="user-profile" [matMenuTriggerFor]="userMenu">
      <div class="user-avatar">
        <mat-icon>account_circle</mat-icon>
      </div>
      <div class="user-info">
        <span class="user-name">{{ userName }}</span>
        <span class="user-status">Online</span>
      </div>
      <mat-icon class="dropdown-arrow">expand_more</mat-icon>
    </div>

    <mat-menu #userMenu="matMenu" class="user-dropdown">
      <div class="user-dropdown-header">
        <div class="dropdown-avatar">
          <mat-icon>account_circle</mat-icon>
        </div>
        <div class="dropdown-user-info">
          <span class="dropdown-name">{{ userName }}</span>
          <span class="dropdown-email">{{ userEmail }}</span>
        </div>
      </div>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="onLogout()" class="logout-item">
        <mat-icon>logout</mat-icon>
        <span>Odjava</span>
      </button>
    </mat-menu>
  </div>
</nav>
